// Mixin des pages du portail client : langue, formats, chargement, PDF.
// Le compte (langue, aperçu admin) vient de ClientLayout (provide 'portal').
import { translate, formatDate, formatAmount } from '@/views/client/i18n.js'
import { portalGet, openPdf, errorMessage, readError } from '@/views/client/portalApi.js'

// Refus de PDF connus (clientportal.controller, PDF_REFUSALS) → texte traduit.
const PDF_ERROR_KEYS = { no_pdf: 'pdf_no_pdf', pdf_outdated: 'pdf_outdated', not_found: 'pdf_not_found' }

export default {
  inject: ['portal'],
  data () {
    return {
      loading: true,
      loadError: null,
      opening: {} // 'order-12' / 'invoice-34' → true pendant l'ouverture du PDF
    }
  },
  computed: {
    manyCompanies () {
      return !!(this.portal.me && this.portal.me.companies.length > 1)
    },
    asQuery () {
      return this.portal.as ? { as: this.portal.as } : {}
    }
  },
  methods: {
    t (key, vars) {
      return translate(this.portal.lang, key, vars)
    },
    date (ymd) {
      return formatDate(this.portal.lang, ymd)
    },
    amount (value, currency) {
      const s = formatAmount(value)
      return s && currency ? `${s} ${currency}` : s
    },
    statusColor (status) {
      return { pending: 'warning', in_progress: 'primary', invoiced: 'success' }[status] || 'dark'
    },
    // Charge une route du portail ; `apply(data)` range le résultat.
    async fetch (path, apply) {
      this.loading = true
      this.loadError = null
      try {
        apply(await portalGet(path, this.portal.as))
      } catch (err) {
        // Messages serveur en anglais : le client lit la phrase de sa langue.
        const preview = !!(this.portal.me && this.portal.me.preview)
        this.loadError = preview ? await errorMessage(err, this.t('load_error')) : this.t('load_error')
      } finally {
        this.loading = false
      }
    },
    open (name, id) {
      this.$router.push({ name, params: { id }, query: this.asQuery }).catch(() => {})
    },
    async viewPdf (kind, id) {
      const key = `${kind}-${id}`
      if (this.opening[key]) return
      this.$set(this.opening, key, true)
      try {
        await openPdf(kind, id, this.portal.as)
      } catch (err) {
        const { code } = await readError(err)
        this.$vs.notify({
          title: 'PDF',
          text: this.t(PDF_ERROR_KEYS[code] || 'download_error'),
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'bottom-right',
          time: 8000
        })
      } finally {
        this.$set(this.opening, key, false)
      }
    }
  }
}
